let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2zIbn")).then(() => parcelRequire('bXyC6'));